import React from "react";
import { Link, IndexLink, Route, Switch } from "react-router-dom";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";
// import { this.props.history } from "react-router";
import * as AdminIndexAction from "../../../actions/admin/Index/adminIndexAction";
import * as appointmentActions from '../../../actions/appointmentActions';
import * as SVGICONS from "../../../images/img/images";
import RoleAwareComponent from "../../authorization/roleaware";
// import { ToastContainer, toast } from "react-toastify";
import DatePicker from 'react-datepicker';
import "react-toastify/dist/ReactToastify.css";
import * as ImageUrl from "../../../constants/constant";
import autoBind from "auto-bind";
import moment from 'moment';
import * as constant from "../../../constants/constant";
import $ from "jquery";
import adminDashboard from "../dashboard/adminDashboard";
import financeUser from "../user/financeUser/financeUser";
import feedbackUserList from "../user/feedbackUserList";
import photoUserList from "../user/photoUserList";
import specialistAssisstantUserList from "../user/specialistAssisstantUserList";
import vettingUserList from "../user/vettingUserList";
import specialistUserList from "../user/specialistUserList";
import patientUserList from "../user/patientUserList";
import SpecialistVerification from "../vettinguser/verification";
import financeUserList from "../user/financeUserList";
import addEdit from "../user/addEdit";
import patientAppointmentHistory from "../user/patientAppointmentHistory";
import allpatientAppointments from "../user/allpatientAppointments";
import appointmentConsultation from "./appointmentConsultation";
import NotFound from "../../common/404";
import emailTemplate from "./emailTemplate";
import emailTemplateList from "./emailTemplateList";
import emailTemplateView from "./emailTemplateView";
import cmsList from "./cmsList";
import cms from "./cms";
import "./adminIndex.css";
import feedbackList from "./feedbackList";
import usersList from "../user/usersList";
import adminSettings from "../settings/adminSettings";
import blogList from "./blogList";
import imageUser from "../user/imageUser/imageUser";
import currencyFilter from "../user/currencyFilter/currencyFilter";
import logsList from "../../logs/logsList";
import userDispute from "../user/userDispute";
import disputeSettings from "../user/disputeSettings";
import languageSettings from "../user/languageSettings";
import * as vettingUserActions from "../../../actions/admin/vettinguser/vettingUserActions.js";
import addBlogs from "./addBlogs";
// import Dashboard from '../../../images/Slicing/dashboard.svg'
//landing page presentational component
class AdminIndex extends RoleAwareComponent {
	constructor(props, context) {
		super(props, context);
		autoBind(this);
		this.state = {
			finance: 'none',
			vetting: 'none',
			feedback: 'none',
			specialistuser: 'none',
			photo: 'none',
			specialistassisstant: 'none',
			admin: 'none',
			logoutButton: false,
			roles: [],
			userData: '',
			flag: 1,
			activePage: 1,
			count: 10,
			blockingDate: new Date(),
			verify: false,

		};
		this.toggle = this.toggle.bind(this)

		this.handleClick = this.handleClick.bind(this);
		this.handleOutsideClick = this.handleOutsideClick.bind(this);

	}
	toggle(e, menuClicked) {
		var windowWidth = $(window).width();
		if (windowWidth <= 768) {
			if (e == true) {
				$("body").toggleClass("sidebar-open");
			} else {
				$("body").toggleClass("sidebar-open");
			}
		}

		// if(windowWidth < 768 ){

		// 	$("body").toggleClass("sidebar-open");
		// }
		if (windowWidth >= 768) {
			if (e == true) {
				$("body").toggleClass("sidebar-collapse");
			} else if (e == false) {
				$("body").toggleClass("sidebar-collapse");
			}
		}
	}
	// toggle() {
	// 	var windowWidth = $(window).width();
	// 	if(windowWidth < 768){
	// 		$("body").toggleClass("sidebar-open");
	// 	}else{
	// 		$("body").toggleClass("sidebar-collapse");
	// 	}	}
	componentWillMount() {
		var roles = localStorage.getItem('roles');
		var userRoles = roles ? roles.split(',') : ['admin'];
		// userRoles.forEach(function (item) {
		// 	// let obj = {}
		// 	// obj[item] = 'block';
		// 	// this.setState(obj)
		// })
		this.setState({
			roles: userRoles,
		})

		// this.props.actions.getSpecializationList(this.props);
	}

	componentWillReceiveProps(nextProps) {

		this.setState({
			userData: nextProps.userData,
			searchZipcode: ''
		})
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};
		if (nextProps.userData && nextProps.userData.gender) {
			user.gender = nextProps.userData.gender;
			localStorage.setItem('user', JSON.stringify(user));
		}
	}

	componentDidMount() {
		// const user = JSON.parse(localStorage.getItem('user'));
	}

	_logout(event) {
		let userId = localStorage.getItem("userId");
		this.props.actions.logout({ userId: userId });
		event.preventDefault();
		localStorage.clear();
		this.props.history.push("/user");
	}

	// obsolete function
	// onLogoutclick = (data) => {
	// 	if (this.state.logoutButton == false) {
	// 		this.setState({
	// 			logoutButton: true
	// 		}, () => {
	// 			// setTimeout(this.setState({logoutButton: !this.state.logoutButton}), 4000)
	// 		});
	// 	}
	// 	else {
	// 		this.setState({
	// 			logoutButton: false
	// 		}, () => {
	// 			// setTimeout(this.setState({logoutButton: !this.state.logoutButton}), 4000)
	// 		});
	// 	}
	// }

	handleOutsideClick(e) {
		// ignore clicks on the component itself
		if (this.node && this.node.contains(e.target)) {
			return;
		}

		this.handleClick();
	}
	handleClick() {
		if (!this.state.logoutButton) {
			// attach/remove event handler
			document.addEventListener('click', this.handleOutsideClick, false);
		} else {
			document.removeEventListener('click', this.handleOutsideClick, false);
		}

		this.setState(prevState => ({
			logoutButton: !prevState.logoutButton,
		}));
	}

	onChange() {
		this.setState({
			searchZipcode: event.target.value
		})

	}
	searchByDashBoard() {
		if (location.pathname == '/user/disputes') {
			let appDetail = {
				patientId: this.props.match.params.patientId,
				count: this.state.count,
				page: this.state.activePage,
				searchedItem: this.state.searchZipcode
			}
			this.props.appointmentActions.getAllDisputedAppointments(appDetail);
			// this.props.actions.searchDisputeById({
			// 	data: this.state.searchZipcode
			// })
		}
		if (location.pathname == '/user/patients') {
			let objectDocument = {
				page: this.state.activePage,
				count: this.state.count,
				userId: localStorage.getItem("userId"),
				searchedItem: this.state.searchZipcode
			};
			this.props.patientActions.getAllPatients(objectDocument);
		}
		if (location.pathname == '/user/specialistuser') {
			let status = this.props.changedSpecialistType === true ? true : false
			let objectDocument = {
				page: 1,
				count: this.state.count,
				status: status,
				userId: localStorage.getItem("userId"),
				searchedItem: this.state.searchZipcode
			};
			this.props.patientActions.getAllSpecialists(objectDocument);
			// this.props.patientActions.getAllPatients(objectDocument);
		}

	}

	blockingDateChanged = (selectedDate) => {
		let todayDate = selectedDate ? selectedDate : this.state.blockingDate
		var convertDate = new Date(moment(todayDate).startOf('day'));
		var convertDateEnd = new Date(moment(todayDate).endOf('day'));
		this.setState({
			blockingDate: convertDate
		})
		// var currenthour = moment(todayDate).local().format("HH")
		// var currentmin = moment(todayDate).local().format("mm")
		// let appointmentObj = {
		//     ...this.state.specialistDetail[0],
		//     currenthour: currenthour,
		//     currentmin: currentmin,
		//     appointmentDate: convertDate,
		//     userlocation: moment.tz.guess(),
		//     avail: true
		// }
		// staring from 1 so 
		let appDetail = {
			patientId: this.props.match.params.patientId,
			count: this.state.count,
			page: this.state.activePage,
			date1: convertDate,
			date2: convertDateEnd,

		}
		if (selectedDate == false)
		this.props.appointmentActions.getPatientAllHistory(appDetail);
	}
	blockingDateChangedFeedbacks = (selectedDate) => {
		let todayDate = selectedDate ? selectedDate : this.state.blockingDate;
		var convertDate = new Date(moment(todayDate));
		this.setState({
			blockingDate: convertDate
		});

		this.props.actions.changeSearchedDate(convertDate);

		// var currenthour = moment(todayDate).local().format("HH")
		// var currentmin = moment(todayDate).local().format("mm")
		// let appointmentObj = {
		//     ...this.state.specialistDetail[0],
		//     currenthour: currenthour,
		//     currentmin: currentmin,
		//     appointmentDate: convertDate,
		//     userlocation: moment.tz.guess(),
		//     avail: true
		// }
		// staring from 1 so 
		const { changedFeedbackType } = this.props;

		if (changedFeedbackType == true) {
			var isSpecialistVerified = false
			var isPatientVerified = true
			var tabName = false

		} else if (changedFeedbackType == false) {
			var isSpecialistVerified = true
			var isPatientVerified = false
			var tabName = true

		} else {
			var tabName = 'Approved'

		}

		// return
		let object = {
			page: this.state.activePage,
			count: this.state.count,
			verify: this.state.verify,
			isSpecialistVerified: isSpecialistVerified,
			isPatientVerified: isPatientVerified,
			isDoctorAddedFeedback: tabName,
			date1: convertDate,
			date2: convertDate,
			
		}
		if (selectedDate == false)
		this.props.actions.getFeedbacksList(object);
	}

	render() {
		var defaultImagePath = localStorage.getItem('Gender') == 'Male' ?
			constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_m.png" : constant.PRODUCTION_IMAGE_URL + "uploads/common/patient_f.png"
		var children = React.Children.map(
			this.props.children,
			function (child) {
				return child;
			}.bind(this)
		);
		var specializationList = this.state.specializationList;
		// var user = { adminImage: "dddd" }
		var user = localStorage.getItem('user') ? JSON.parse(localStorage.getItem('user')) : {};

		if ((user && user.adminImage) == "noUserImage.jpg" || !(user && user.adminImage)) {
			var imagePath = (user && user.gender) == 'Male' ? ImageUrl.PRODUCTION_IMAGE_URL + 'uploads/' + "common/" + 'patient_m.png' : ImageUrl.PRODUCTION_IMAGE_URL + 'uploads/' + "common/" + 'patient_f.png';
		} else {
			var imagePath =
				ImageUrl.PRODUCTION_IMAGE_URL +
				"uploads/" +
				'admin' +
				"/" +
				user.adminImage;
		}
		var sidebartoggle = true;
		// var condition = user.userName == undefined || user.gender == undefined;
		var windowWidth = $(window).width();
		var condition2 = windowWidth >= 768;
		return (
			<div className="wrapper">
				<header className="main-header">
					{/* <ToastContainer /> */}
					<Link to="/user/superuser-dashboard" className="logo">
						<span className="logo-mini">
							<img src={require("../../../images/img/logo_er_ms.png")} alt="" />
						</span>
						<span className="logo-lg">
							<img src={require("../../../images/img/logo_er.png")} alt="" />
						</span>
					</Link>


					<nav className="navbar navbar-static-top" role="navigation">
						<a
							href="#"
							className="sidebar-toggle"
							data-toggle="push-menu"
							role="button"
							onClick={this.toggle.bind(this, !sidebartoggle)}
						>

							<img
								src={require("../../../images/img/menu_list.svg")}
								alt=""
							/>
							<span className="sr-only">Toggle navigation</span>
						</a>
						{location.pathname === "/user/disputes" ||
							location.pathname === "/user/patients" ||
							location.pathname === "/user/specialistuser" ||
							location.pathname === "verify-user" ||
							location.pathname === "/my-health-record" ||
							location.pathname === "/my-setting" ||
							location.pathname === "/booking-confirmation" ? (
								<div className="topSearch">
									<div className="row">
										<div className="col-md-10">
											<div className="input-group inputBg">

												<span className="input-group-addon">
													<i className="fa ">
														<img
															src={require("../../../images/img/search.png")}
															alt=""
														/>
													</i>
												</span>
												<input
													type="text"
													name="searchZipcode"
													className="form-control"
													onChange={this.onChange.bind(this)}
													value={this.state.searchZipcode}
													placeholder={location.pathname === "/user/patients" ? "Patient Email" :
														location.pathname === "/user/specialistuser" ? "Specialist Email" :
															"Dispute Id"}
												// maxLength="10"
												/>
											</div>
										</div>
										<div className="col-md-2">
											<div className="searchBtn specialistSearch">
												<button
													type="button"
													onClick={this.searchByDashBoard.bind(this)}
													className="btn btn-block btn-warning btn-lg"
													disabled={this.state.isSearch}
												>
													Search
                      </button>
											</div>
										</div>
									</div>
								</div>
							) : location.pathname == '/user/appointments' ? <div className="col-lg-4 col-md-4">
								<div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">
									<div className="input-group date inputBg dateInputfild" style={{ color: '#4d4d4d !important' }}>
										<div className="input-group-addon"><i className="fa ">
											<img src={require('../../../images/img/date_input_icon.svg')} /></i></div>
										<DatePicker
											name="blockingdate"
											dateFormat="dd-MM-yyyy"
											selected={this.state.blockingDate}
											onChange={this.blockingDateChanged}
											placeholderText="Date"
											// maxDate={moment().add(2, 'year')}
											// minDate={new Date()}
											showMonthDropdown
											showYearDropdown={true}
											shouldCloseOnSelect={true}
										/>
									</div>
								</div>
									<div className=" searchBtn">
												<button
													type="button"
													onClick={() => this.blockingDateChanged(false)}
													className="btn btn-block btn-warning btn-lg"
													disabled={this.state.isSearch}
												>
													Search
                      </button>
											</div>
							</div>
								: location.pathname == '/user/Feedbacks' ? <div className="col-lg-4 col-md-4">
									<div className="date-picker form__form-group-input-wrap form__form-group-input-wrap--error-above">
										<div className="input-group date inputBg dateInputfild" style={{ color: '#4d4d4d !important' }}>
											<div className="input-group-addon"><i className="fa ">
												<img src={require('../../../images/img/date_input_icon.svg')} /></i></div>
											<DatePicker
												name="blockingdate"
												dateFormat="dd-MM-yyyy"
												selected={this.state.blockingDate}
												onChange={this.blockingDateChangedFeedbacks}
												placeholderText="Date"
												// maxDate={moment().add(2, 'year')}
												// minDate={new Date()}
												showMonthDropdown
												showYearDropdown={true}
												shouldCloseOnSelect={true}
											/>
										</div>
									</div>
									<div className=" searchBtn">
												<button
													type="button"
													onClick={() => this.blockingDateChangedFeedbacks(false)}
													className="btn btn-block btn-warning btn-lg"
													disabled={this.state.isSearch}
												>
													Search
                      </button>
											</div>
								</div> : ''}
						<div className="navbar-custom-menu">
							<ul className="nav navbar-nav">
								<li className="dropdown user user-menu">
									<li ref={node => { this.node = node; }} onClick={this.handleClick} className={this.state.logoutButton == true ? "dropdown user user-menu show" : "dropdown user user-menu"}>

										<a
											href="#"
											className="dropdown-toggle"
											data-toggle="dropdown"
										>
											<img
												src={imagePath}
												className="user-image"
												alt="User Image"
												onError={e => {
													e.target.src = defaultImagePath;
												}}
											/>
											<span className="hidden-xs name-capitalize">
												{(user && user.userName) ? user.userName : "Medfix User"}
											</span>
										</a>
										<ul className={this.state.logoutButton === true ? "dropdown-logout-menu" : "dropdown-menu popupdropdown"}>


											<li
												className="user-footer passwordLink"
											// style={{ textAlign: "center" }}
											>

												<a
													to="#"
													className="uploadLink"
													onClick={this._logout}
												>
													<img
														src={require('../../../images/Slicing/logout-profile.png')}
														className="user-image"
														alt="User Image"
														onError={e => {
															e.target.src = defaultImagePath;
														}}
													/>
													<span>	Sign out</span>
												</a>
											</li>
										</ul>
									</li>
								</li>
							</ul>
						</div>
					</nav>
				</header>

				<aside className="main-sidebar adminSidbar">
					<section className="sidebar">
						<ul className="sidebar-menu" data-widget="tree">
							<li className={location.pathname === "/user/superuser-dashboard" ? "active" : ""} style={{ 'display': (this.state.roles.indexOf('admin') != -1) ? 'block' : 'none' }}>
								<Link to={"/user/superuser-dashboard"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa ">
										<SVGICONS.BookAppointmentSvg />
									</i> */}
									{/* <i className="fa fa-tachometer fa-6" aria-hidden="false" style={{ 'color': (location.pathname != "/user/superuser-dashboard" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									<i className="fa "><SVGICONS.Dashboardsvg /></i>
									<span>Dashboard</span>
								</Link>
							</li>
							<li className={location.pathname === "/user/finance-dashboard" ? "active" : ""} style={{ 'display': (this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('finance') != -1) ? 'block' : 'none' }}>

								<Link to={"/user/finance-dashboard"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>

									<i className="fa ">	<SVGICONS.Financesvg /></i>
									<span>Finance</span>
								</Link>
							</li>
							<li className={location.pathname === "/user/userList" ? "active" : ""} style={{ 'display': (this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('admin') != -1) ? 'block' : 'none' }}>
								<Link to={"/user/userList"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa ">
										
									</i> */}
									<i className="fa "><SVGICONS.Userssvg /></i>
									{/* <i className="fa fa-user fa-6" aria-hidden="false" style={{ 'color': (location.pathname != "/user/userList" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									<span> Users</span>
								</Link>
							</li>
							{/* <li className={location.pathname === "/user/financeuser" ? "active" : ""} style={{ 'display': (this.state.roles.indexOf('finance') != -1 || this.state.roles.indexOf('admin') != -1) ? 'block' : 'none' }}>
								<Link to={"/user/financeuser"} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }>
									
									<i className="fa fa-money fa-6" aria-hidden="false" style={{ 'color': (location.pathname != "/user/financeuser" ? '#00b5e8' : '#FFFFFF') }}></i>
									<span>Finance User</span>
								</Link>
							</li> */}
							{/* <li
								className={location.pathname === "/user/feedbackuser" ? "active" : ""} style={{ 'display': (this.state.roles.indexOf('feedback') != -1 || this.state.roles.indexOf('admin') != -1) ? 'block' : 'none' }}>
								<Link to={"/user/feedbackuser"} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }>
								
									<i className="fa fa-comments fa-6" aria-hidden="false" style={{ 'color': (location.pathname != "/user/feedbackuser" ? '#00b5e8' : '#FFFFFF') }}></i>
									<span>Feedback User</span>
								</Link>
							</li> */}
							{/* <li className={
								location.pathname === "/user/vettinguser" ? "active" : ""
              } style={{ 'display': (this.state.roles.indexOf('admin') != -1) ? 'block' : 'none' }}
              // this.state.roles.indexOf('vetting') != -1 ||
							>

								<Link to={"/user/vettinguser"} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }>
									
									<i className="fa fa-search fa-6" aria-hidden="false" style={{ 'color': (location.pathname != "/user/vettinguser" ? '#00b5e8' : '#FFFFFF') }}></i>
									<span>Vetting User</span>
								</Link>
							</li> */}
							<li
								className={
									location.pathname === "/user/specialistuser" ? "active" : ""
								} style={{ 'display': (this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('vetting') != -1 || this.state.roles.indexOf('admin') != -1) ? 'block' : 'none' }}
							>

								<Link to={"/user/specialistuser"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa ">
									
									</i> */}
									<i className="fa ">	<SVGICONS.SpecialistProfileLeftSvg /></i>
									{/* <i className="fa fa-stethoscope fa-6" aria-hidden="false" style={{ 'color': (location.pathname != "/user/specialistuser" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									<span>Specialists</span>
								</Link>
							</li>
							<li
								className={
									location.pathname === "/user/patients" ? "active" : ""
								} style={{ 'display': (this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('admin') != -1) ? 'block' : 'none' }}
							>

								<Link to={"/user/patients"} className="patientmarginright" onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa ">
										<SVGICONS.BookAppointmentSvg />
									</i> */}
									<i className="fa ">  <SVGICONS.Patientsvg /></i>

									{/* <i className="fa fa-stethoscope fa-6" aria-hidden="false" style={{ 'color': (location.pathname != "/user/patients" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									<span>Patients</span>
								</Link>
							</li>

							{/* <li
								className={
									location.pathname === "/user/photouser" ? "active" : ""
								} style={{ 'display': (this.state.roles.indexOf('photo') != -1 || this.state.roles.indexOf('admin') != -1) ? 'block' : 'none' }}
							>

								<Link to={"/user/photouser"} onClick={ condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false) }>
									
									<i className="fa fa-camera fa-6" aria-hidden="false" style={{ 'color': (location.pathname != "/user/photouser" ? '#00b5e8' : '#FFFFFF') }}></i>
									<span>Photo User</span>
								</Link>
							</li> */}
							{/* <li
								className={
									location.pathname === "/user/patientuser" ? "active" : ""
								}
							>

								<Link to={"/user/patientuser"}>
									<i className="fa ">
										<SVGICONS.BookAppointmentSvg />
									</i>
									<span>Patient User</span>
								</Link>
							</li> */}
							<li
								className={
									location.pathname === "/user/specialist-assisstant"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('specialistassisstant') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/specialist-assisstant"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									<i className="fa ">
										<i className="fa "><SVGICONS.BookAppointmentSvg /></i>
									</i>
									<span>Specialist Assisstant</span>
								</Link>
							</li>
							<li
								className={
									location.pathname === "/user/email-templates"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/email-templates"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa ">
										<SVGICONS.BookAppointmentSvg />
									</i> */}
									<i className="fa "><SVGICONS.Emailsvg /></i>

									{/* <i className="fa fa-envelope-open fa-6" aria-hidden="false" style={{ 'color': (location.pathname != "/user/email-templates" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									<span>Email Templates</span>
								</Link>
							</li>

							<li
								className={
									location.pathname === "/user/pages"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/pages"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa "> */}
									{/* <i className="fa fa-file-text-o fa-6" aria-hidden="true" style={{ 'color': (location.pathname != "/user/pages" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									{/* </i> */}
									<i className="fa "><SVGICONS.Cmssvg /></i>
									<span>CMS</span>
								</Link>
							</li>

							<li
								className={
									location.pathname === "/user/logs"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/logs"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa "> */}
									{/* <i className="fa fa-file-text-o fa-6" aria-hidden="true" style={{ 'color': (location.pathname != "/user/logs" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									{/* </i> */}
									<i className="fa "><SVGICONS.Logssvg /></i>
									<span>Logs</span>
								</Link>
							</li>

							<li
								className={
									location.pathname === "/user/appointments"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/appointments"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa "> */}
									{/* <i className="fa fa-file-text-o fa-6" aria-hidden="true" style={{ 'color': (location.pathname != "/user/appointments" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									{/* </i> */}
									<i className="fa "><SVGICONS.Appointmentssvg /></i>
									<span>Appointments</span>
								</Link>

							</li>
							<li
								className={
									location.pathname === "/user/Feedbacks"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('feedback') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/Feedbacks"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa "> */}
									{/* <i className="fa fa-file-text-o fa-6" aria-hidden="true" style={{ 'color': (location.pathname != "/user/Feedbacks" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									{/* </i> */}
									<i className="fa "><SVGICONS.Feedbacksvg /></i>
									<span>Feedbacks</span>
								</Link>

							</li>
							<li
								className={
									location.pathname === "/user/disputes"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('feedback') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/disputes"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa "> */}
									{/* <i className="fa fa-file-text-o fa-6" aria-hidden="true" style={{ 'color': (location.pathname != "/user/Feedbacks" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									{/* </i> */}
									<i className="fa "><SVGICONS.Feedbacksvg /></i>
									<span>Disputes</span>
								</Link>

							</li>
							<li
								className={
									location.pathname === "/user/adminblogList"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('feedback') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/adminblogList"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa "> */}
									{/* <i className="fa fa-file-text-o fa-6" aria-hidden="true" style={{ 'color': (location.pathname != "/user/Feedbacks" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									{/* </i> */}
									<i className="fa "><SVGICONS.Feedbacksvg /></i>
									<span>Blogs</span>
								</Link>

							</li>
							<li
								className={
									location.pathname === "/user/language"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('feedback') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/language"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>
									{/* <i className="fa "> */}
									{/* <i className="fa fa-file-text-o fa-6" aria-hidden="true" style={{ 'color': (location.pathname != "/user/Feedbacks" ? '#00b5e8' : '#FFFFFF') }}></i> */}
									{/* </i> */}
									<i className="fa "><SVGICONS.Feedbacksvg /></i>
									<span>Language</span>
								</Link>

							</li>
							<li
								className={
									location.pathname === "/user/Images"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('photouser') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/Images"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>

									<i className="fa "><SVGICONS.Imagessvg /></i>
									<span>Images</span>
								</Link>

							</li>
							<li
								className={
									location.pathname === "/user/currency-filter"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/currency-filter"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>

									<i className="fa "><SVGICONS.Financesvg /></i>
									<span>Currency Filter</span>
								</Link>
							</li>
							<li
								className={
									location.pathname === "/user/userSetting"
										? "active"
										: ""
								} style={{ 'display': this.state.roles.indexOf('admin') != -1 || this.state.roles.indexOf('feedback') != -1 || this.state.roles.indexOf('vetting') != -1 || this.state.roles.indexOf('finance') != -1 || this.state.roles.indexOf('photouser') != -1 ? 'block' : 'none' }}
							>

								<Link to={"/user/userSetting"} onClick={condition2 ? this.toggle.bind(this, 'dont') : this.toggle.bind(this, false)}>

									<i className="fa "><SVGICONS.SettingsSvg /></i>
									<span>Settings</span>
								</Link>
							</li>
						</ul>

					</section>
				</aside>
				<div>
					<Switch>
						<Route exact path="/user" component={adminDashboard} />
						<Route exact path="/user/superuser-dashboard" component={adminDashboard} />
						<Route exact path="/user/disputes" component={disputeSettings} />
						<Route exact path="/user/language" component={languageSettings} />
						<Route exact path="/user/finance-dashboard" component={financeUser} />
						<Route exact path="/user/feedbackuser" component={feedbackUserList} />
						<Route exact path="/user/photouser" component={photoUserList} />
						<Route exact path="/user/specialist-assisstant" component={specialistAssisstantUserList} />
						<Route exact path="/user/vettinguser" component={vettingUserList} />
						<Route exact path="/user/specialistuser" component={specialistUserList} />
						<Route exact path="/user/patients" component={patientUserList} />
						<Route exact path="/user/verification/:specialistId" component={SpecialistVerification} />
						<Route exact path="/user/financeuser" component={financeUserList} />
						<Route exact path="/user/add-user" component={addEdit} />
						<Route exact path="/user/edit-user/:userId" component={addEdit} />
						<Route exact path="/user/patient-appointments/:patientId" component={patientAppointmentHistory} />
						<Route exact path="/user/appointments" component={allpatientAppointments} />
						<Route exact path="/user/appointment-consultation/:appointmentId" component={appointmentConsultation} />
						<Route exact path="/user/add-email-template" component={emailTemplate} />
						<Route exact path="/user/email-templates" component={emailTemplateList} />
						<Route exact path="/user/edit-email-template/:templateId" component={emailTemplate} />
						<Route exact path="/user/emailTemplateView/:templateId" component={emailTemplateView} />
						<Route exact path="/user/pages" component={cmsList} />
						<Route exact path="/user/edit-page/:pageId" component={cms} />
						<Route exact path="/user/feedbacks" component={feedbackList} />
						<Route exact path="/user/userList" component={usersList} />
						<Route exact path="/user/userSetting" component={adminSettings} />
						<Route exact path="/user/adminblogList" component={blogList} />
						<Route exact path="/user/add-blog" component={addBlogs} />
						<Route exact path="/user/Images" component={imageUser} />
						<Route exact path="/user/currency-filter" component={currencyFilter} />
						<Route exact path="/user/logs" component={logsList} />
						{/* <Route exact path="/user/blogs" component={blogList} /> */}
						<Route exact path="/user/disputes/:disputeId" component={userDispute} />
						<Route exact path="*" component={NotFound} />

						{/* <Route exact path="/user/logs" component={Logs}  /> */}

					</Switch>
				</div>

			</div >
		);
	}
}
{/* //this tells what state should expose on props */ }
function mapStateToProps(state, ownProps) {
	return {
		userData: state.adminUser.userData ? state.adminUser.userData : {},
		changedSpecialistType: state.adminUser ? state.adminUser.changedSpecialistType : true,
		changedFeedbackType: state.adminUser ? state.adminUser.changedFeedbackType : true,
	};
}

{/* //bindActionCreators is used to bind all actions at once */ }
function mapDispatchToProps(dispatch) {
	return {
		actions: bindActionCreators(AdminIndexAction, dispatch),
		appointmentActions: bindActionCreators(appointmentActions, dispatch),
		patientActions: bindActionCreators(vettingUserActions, dispatch)


	};
}
export default connect(
	mapStateToProps,
	mapDispatchToProps
)(AdminIndex);
